// On 'predicate select' change, change also its comanion textfield name

document.addEventListener('change', (event) => {
  if(event.target.matches('select[ransackfilter]')) {
    let input = Array.prototype.filter.call(event.target.parentNode.parentNode.children[1].children, (child) => child != event.target && child.nodeName.toLowerCase() == 'input')[0]
    input.attributes.name.value = input.attributes.name.value.replace(/(_not)?_[a-zA-Z0-9]+(?=\]$)/, '_' + event.target.selectedOptions[0].value)
  }
})